import {
  Typography,
  Box,
  Link,
  Divider,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Modal,
  CircularProgress,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SystemInfoTable from "./systemInfoTable";
import NotActiveLicenseTable from "./notActiveLicenseTable";
import UploadFile from "./uploadFile";
import CommandConsole from "./CommandConsole";
import { useCallback, useEffect, useState } from "react";
import SystemInfoApi from "./api";
import InfoIcon from "@mui/icons-material/Info";
import api from "../../app/api";
import { enqueueSnackbar } from "notistack";
import { USER_NAME_ROLE } from "src/app/auth";
import { licenseActions } from "src/contants";
import CommonApi from "src/commonApi";
import { convertUTCDateToLocalTime } from "src/app/utils/helper";
import { FaCircle } from "react-icons/fa";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
interface SystemHealthDetails {
  cpu_usage: string;
  memory_usage: {
    used: string;
    total: string;
    percentage: string;
  };
  disk_usage: {
    used: string;
    total: string;
    percentage: string;
  };
  cpu_temperature: string;
}

const SystemConfiguration = () => {
  const [poppup, setPoppup] = useState(false);
  const [resetViboxPopup, setResetViboxPopup] = useState(false);
  const [resetVib360Popup, setResetVib360Popup] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [apiData, setApiData] = useState<any>();
  const [versionData, setVersionData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [systemHealthPopup, setSystemHealthPopup] = useState(false);
  const [systemHealthLogs, setSystemHealthLogs] = useState("");
  const [isSystemHealthLoading, setIsSystemHealthLoading] = useState(false);
  const [vib360RunningStatus, setVib360RunningStatus] = useState("");
  const [systemHealthDetails, setSystemHealthDetails] =
    useState<SystemHealthDetails>({
      cpu_usage: "0%",
      memory_usage: { used: "0", total: "0", percentage: "0%" },
      disk_usage: { used: "0", total: "0", percentage: "0%" },
      cpu_temperature: "",
    });
  const [showCommandConsole, setShowCommandConsole] = useState(false);


  const getVersionInfo = async () => {
    try {
      const response = await SystemInfoApi.getVersionInfo();
      const versionData = response.data;
      if (versionData && versionData.log) {
        setVersionData((prev: any) => ({
          ...prev,
          version: versionData.log,
        }));
      } else {
        console.error("Unexpected response format:", versionData);
      }
    } catch (error) {
      console.error("Error fetching version information:", error);
    }
  };

  const getSystemInfo = async (force = false) => {
    if (apiData && !force) {
      return;
    }
    const response = await SystemInfoApi.getSystemInfo();
    setApiData((val: any) => {
      return {
        ...val,
        ...response?.data,
      };
    });
  };

  const getVibRunningStatus = async () => {
    try {
      const response = await SystemInfoApi.getVib360RunningStatus();
      const statusData = response?.data;

      if (statusData && statusData?.Status) {
        setVib360RunningStatus(statusData?.data);
      } else {
        console.error(
          "Unexpected response format for Vib360 status:",
          statusData
        );
      }
    } catch (error) {
      console.error("Error fetching Vib360 running status:", error);
    }
  };

  const getSystemHealthMonitoringDetails = async () => {
    try {
      const response = await SystemInfoApi.getSystemHealthMonitoringDetails();
      const statusData = response?.data;
      console.log("statusData", statusData);

      if (statusData && statusData?.Status === "Success" && statusData?.data?.summary) {
        setSystemHealthDetails(statusData.data.summary);
      } else if (statusData?.data?.summary) {
        // Fallback: use summary directly if Status is missing
        setSystemHealthDetails(statusData.data.summary);
      } else {
        console.error(
          "Unexpected response format for Vib360 status:",
          statusData
        );
      }
    } catch (error) {
      console.error("Error fetching Vib360 running status:", error);
    }
  };
  useEffect(() => {
    if (!apiData) {
      getSystemInfo();
    }
    getVersionInfo();
  }, [apiData]);

  useEffect(() => {
    // call once immediately
    getVibRunningStatus();
    getSystemHealthMonitoringDetails();
    // then call every 30 seconds
    const interval = setInterval(() => {
      getVibRunningStatus();
      getSystemHealthMonitoringDetails();
    }, 30000);

    // cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  const handleClick = async () => {
    api.get(
      `${window.location.origin}/client-portal-api/app/start_dashboard_socket.php`
    );
    api.get(
      `${window.location.origin}/client-portal-api/app/start_signal_socket.php`
    );
    api.get(
      `${window.location.origin}/client-portal-api/app/start_status_socket.php`
    );
    await addSystemStatusLog("Restart Websocket", "Success");

    window.location.reload();
  };

  const addSystemStatusLog = async (type: string, status: string) => {
    try {
      const res = await api.post("/system_status_logs/addSystemStatusLog.php", {
        created_by: sessionStorage.getItem(USER_NAME_ROLE) == "admin" ? 1 : 2,
        status,
        type,
      });

      console.log("System status log added successfully:", res.data);
      return res;
    } catch (error) {
      console.error("Error adding system status log:", error);
      throw error;
    }
  };

  const addSystemHealthLog = (type: string) => {
    setIsSystemHealthLoading(true);
    api
      .post("/system_health_logs/addSystemHealthLog.php", {
        created_by: sessionStorage.getItem(USER_NAME_ROLE) == "admin" ? 1 : 2,
        type: "save",
      })
      .then((res) => {
        setPoppup(false);
        if (type === "click") {
          console.log(res.data?.data?.summary);
          const logSummary = res.data?.data?.summary;
          const logDetailtext = res.data?.data?.details;
          const loggedTimestamp = convertUTCDateToLocalTime(
            new Date(res.data?.data?.timestamp * 1000)
          );
          const logs = [
            `[${loggedTimestamp}] Integrity Check: ${logSummary.file_integrity_status} - ${logDetailtext.file_integrity_detail}`,
            `[${loggedTimestamp}] Services Check: ${logSummary.process_status} - ${logDetailtext.process_detail}`,
            `[${loggedTimestamp}] CPU Check: ${logSummary.cpu_dos_status} - ${logDetailtext.cpu_detail}`,
            `[${loggedTimestamp}] Filesystem Check: ${logSummary.filesystem_status} - ${logDetailtext.filesystem_detail}`,
            `[${loggedTimestamp}] Audit Log Check: ${logSummary.audit_log_status}`,
          ].join("\n");
          setSystemHealthLogs(logs);
          setIsSystemHealthLoading(false);
          setSystemHealthPopup(true);
          // enqueueSnackbar({
          //   message: "System health log added successfully",
          //   variant: "success",
          // });
        }
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar({
          message: "Error while adding the status log",
          variant: "error",
        });
        setIsSystemHealthLoading(false);
        setPoppup(false);
        CommonApi.addAuditFailureLog({
          type: "System health log",
          reason: error?.Message,
          created_by: sessionStorage.getItem(USER_NAME_ROLE) == "admin" ? 1 : 2,
        });
      });
  };

  // Convert health % to color
  const getHealthColor = (value: number): string => {    
    if (value < 50) return "green"; // Healthy
    if (value < 80) return "orange"; // Warning
    return "red"; // Critical
  };

  const revokeLicense = () => {
    api
      .get("/license/delete_license.php")
      .then((res) => {
        setPoppup(false);
        enqueueSnackbar({
          message: "You have Succesfully removed the license",
          variant: "success",
        });
        addLicenseRevokedLog();
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar({
          message: "Error While Revoking the License",
          variant: "error",
        });
        setPoppup(false);
      });

    console.log("apidata", apiData);
  };

  const addLicenseRevokedLog = async () => {
    const payload = {
      license_number: apiData?.licenseInfo?.license_number,
      serial_no: apiData?.licenseInfo?.vbox_serial_number,
      activation_date: apiData?.licenseInfo?.approved_date,
      expiry_date: apiData?.licenseInfo?.expiry_date,
      created_by: sessionStorage.getItem(USER_NAME_ROLE) === "admin" ? 1 : 2,
      action: licenseActions["REVOKED"],
    };

    try {
      await CommonApi.addLicenseLog(payload);
      console.log("log added successfully");

      // Reload after success
      window.location.reload();
    } catch (err:any) {
      console.error("error while adding log", err);

      // Insert failure log
      await CommonApi.addAuditFailureLog({
        type: "License log",
        reason: err?.Message,
        created_by: sessionStorage.getItem(USER_NAME_ROLE) === "admin" ? 1 : 2,
      });

      // Reload after failure log is saved
      window.location.reload();
    }
  };
  // inside SystemConfiguration component (near other handlers like handleClick, revokeLicense)
  const fmtBytes = (bytes: number | undefined | null) => {
    if (!bytes && bytes !== 0) return "n/a";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    const i = Math.max(0, Math.floor(Math.log(bytes) / Math.log(k)));
    return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
  };

  const buildMemoryPayload = (rawApiData: any) => {
    // Expect memory: { total, used, free, usedPercent } and disks: [{ filesystem, size, used, available, usePercent, mount }]
    const memory = rawApiData?.memory || null;
    const disks = rawApiData?.disks || [];
    return { memory, disks, fetchedAt: new Date().toISOString() };
  };

  const downloadAsCSV = async () => {
    try {
      let dataSource = apiData;
      if (!dataSource || (!dataSource.memory && !dataSource.disks)) {
        const resp = await SystemInfoApi.getSystemInfo();
        dataSource = { ...(dataSource || {}), ...(resp?.data || {}) };
      }
      const { memory, disks } = buildMemoryPayload(dataSource);

      // CSV: first a Memory section, then a blank line, then disks table
      const rows: string[] = [];
      rows.push('"Section","Key","Value"');
      if (memory) {
        rows.push(`"Memory","total","${memory.total || ""}"`);
        rows.push(`"Memory","used","${memory.used || ""}"`);
        rows.push(`"Memory","free","${memory.free || ""}"`);
        rows.push(`"Memory","usedPercent","${memory.usedPercent || ""}"`);
        // Add human readable
        rows.push(`"Memory (human)","total","${fmtBytes(memory.total)}"`);
        rows.push(`"Memory (human)","used","${fmtBytes(memory.used)}"`);
        rows.push(`"Memory (human)","free","${fmtBytes(memory.free)}"`);
      } else {
        rows.push(`"Memory","info","not available"`);
      }

      rows.push(""); // blank line
      rows.push(
        '"Filesystem","Size (bytes)","Size (human)","Used (bytes)","Used (human)","Available (bytes)","Available (human)","Use%","Mounted on"'
      );

      if (Array.isArray(disks) && disks.length) {
        disks.forEach((d: any) => {
          const size = d.size ?? "";
          const used = d.used ?? "";
          const avail = d.available ?? "";
          const usePercent = d.usePercent ?? "";
          const mount = d.mount ?? d["Mounted on"] ?? "";
          const fs = d.filesystem ?? d["Filesystem"] ?? "";
          rows.push(
            `"${fs}","${size}","${fmtBytes(size)}","${used}","${fmtBytes(
              used
            )}","${avail}","${fmtBytes(avail)}","${usePercent}","${mount}"`
          );
        });
      } else {
        rows.push(`"n/a","n/a","n/a","n/a","n/a","n/a","n/a","n/a","n/a"`);
      }

      const csv = rows.join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `system-memory-${new Date().toISOString()}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
      enqueueSnackbar({
        message: "Memory details CSV downloaded",
        variant: "success",
      });
    } catch (err) {
      console.error("Download CSV error", err);
      enqueueSnackbar({
        message: "Error downloading memory CSV",
        variant: "error",
      });
    }
  };

  const resetVibox = useCallback(() => {
    setLoading(true);
    api
      .get("/tools/restart-vbox.php")
      .then((res) => {
        addSystemStatusLog("Restart Vibox", "Success");
        enqueueSnackbar({
          message: "You have successfully restarted the Vibox",
          variant: "success",
        });
      })
      .catch((error) => {
        addSystemStatusLog("Restart Vibox", "Error");
        console.error(error);
        enqueueSnackbar({
          message: "Error while restarting the Vibox",
          variant: "error",
        });
      })
      .finally(() => {
        setResetViboxPopup(false);
        setLoading(false);
      });
  }, []);

  const resetVib360 = useCallback(() => {
    setLoading(true);

    api
      .get("/tools/restart-vib360.php")
      .then((res) => {
        enqueueSnackbar({
          message: "You have successfully restarted Vib360",
          variant: "success",
        });
        addSystemStatusLog("Restart Vib360", "Success");
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar({
          message: "Error while restarting Vib360",
          variant: "error",
        });
        addSystemStatusLog("Restart Vib360", "Failed");
      })
      .finally(() => {
        setLoading(false);
        setResetVib360Popup(false);
      });
  }, []);

  const userNameRole = sessionStorage.getItem(USER_NAME_ROLE);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5">System Configuration</Typography>
        <Box>
          <Button
            size="small"
            sx={{ mr: "18px" }}
            variant="contained"
            onClick={() => addSystemHealthLog("click")}
            startIcon={
              isSystemHealthLoading ? (
                <CircularProgress size={10} sx={{ color: "white" }} />
              ) : (
                <></>
              )
            }
          >
            Check System Health
          </Button>
          <Button
            size="small"
            sx={{ mr: "18px" }}
            variant="outlined"
            onClick={handleClick}
          >
            Restart WebSocket
          </Button>
          {/* Download Memory details (JSON & CSV) */}
            {/* <Button
              size="small"
              sx={{ mr: "12px" }}
              variant="contained"
              onClick={downloadAsCSV}
            >
              Download Memory (CSV)
            </Button> */}

          {/* <Button
    size="small"
    sx={{ mr: "18px" }}
    variant="outlined"
    onClick={downloadAsJSON}
  >
    Download Memory (JSON)
  </Button> */}
          {userNameRole === "admin" ? (
            <>
          <Button
            size="small"
            variant="contained"
            onClick={() => setShowCommandConsole(true)}
          >
            Open Command Console
          </Button> &nbsp;
              <Button
                size="small"
                sx={{ mr: "18px", color: "red" }}
                variant="outlined"
                onClick={() => setPoppup(true)}
              >
                Revoke license
              </Button>
              <Button
                size="small"
                sx={{ mr: "18px", color: "red" }}
                variant="outlined"
                onClick={() => setResetViboxPopup(true)}
              >
                Restart Vibox
              </Button>
              <Button
                size="small"
                sx={{ mr: "18px", color: "red" }}
                variant="outlined"
                onClick={() => setResetVib360Popup(true)}
              >
                Restart Vib360
              </Button>
            </>
          ) : (
            ""
          )}
        </Box>
      </Box>
      <Modal
        open={poppup}
        onClose={() => setPoppup(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you really want to revoke current license. it will cause data
            loss.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button sx={{ mr: 1 }} variant="contained" onClick={revokeLicense}>
              yes
            </Button>
            <Button variant="contained" onClick={() => setPoppup(false)}>
              No
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={resetViboxPopup}
        onClose={() => setResetViboxPopup(false)}
        aria-labelledby="reset-vibox-title"
      >
        <Box sx={style}>
          <Typography id="reset-vibox-title" variant="h6" component="h2">
            Are you sure that you want to restart the Vibox?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              onClick={resetVibox}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={10} /> : <></>}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => setResetViboxPopup(false)}
              disabled={loading}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={resetVib360Popup}
        onClose={() => setResetVib360Popup(false)}
        aria-labelledby="reset-vib360-title"
      >
        <Box sx={style}>
          <Typography id="reset-vib360-title" variant="h6" component="h2">
            Are you sure that you want to restart Vib360?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              onClick={resetVib360}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={10} /> : <></>}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => setResetVib360Popup(false)}
              disabled={loading}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={systemHealthPopup}
        onClose={() => setSystemHealthPopup(false)}
        aria-labelledby="system-health-popup"
      >
        <Box
          sx={{
            ...style,
            width: 1000,
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          <Typography
            id="system-health-popup-title"
            variant="h6"
            component="h2"
          >
            Current System Health Log -
          </Typography>
          <Box
            sx={{
              mt: 2,
              background: "#f5f5f5",
              padding: 2,
              borderRadius: 1,
              fontFamily: "monospace",
              whiteSpace: "pre-wrap", // important for multiline logs
              maxHeight: "55vh",
              overflowY: "auto",
            }}
          >
            {systemHealthLogs}
          </Box>
        </Box>
      </Modal>
      <Box
        sx={{
          m: 2,
          ml: 0,
          py: 3,
          px: 4,
          display: "flex",
          bgcolor: (theme) => {
            return theme.palette.color3.main;
          },
          flexDirection: "column",
        }}
      >
        {(vib360RunningStatus || systemHealthDetails?.cpu_usage) && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 1,
              mb: 2,
              gap: 4,
            }}
          >
            {/* CPU Usage */}
            <Box sx={{ width: 220 }}>
              <Typography fontWeight={600} sx={{ mb: 0.5 }}>
                CPU Usage: {systemHealthDetails.cpu_usage || 0}
              </Typography>
              <Box
                sx={{
                  height: 12,
                  width: "100%",
                  bgcolor: "#e0e0e0",
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${Number(
                      systemHealthDetails.cpu_usage?.replace("%", "") || 0
                    )}%`,
                    bgcolor: getHealthColor(
                      Number(systemHealthDetails.cpu_usage?.replace("%", "")) || 0
                    ),
                    borderRadius: 10,
                    transition: "width 0.4s ease",
                  }}
                />
              </Box>
            </Box>

            {/* CPU Temperature */}
            {/* <Box sx={{ width: 220 }}>
              <Typography fontWeight={600} sx={{ mb: 0.5 }}>
                CPU Temperature: {systemHealthDetails.cpu_temperature?.toString()?.split(".")[0] || "0"} °C
              </Typography>
              <Box
                sx={{
                  height: 12,
                  width: "100%",
                  bgcolor: "#e0e0e0",
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${Number(
                      systemHealthDetails.cpu_temperature?.toString()?.split(".")[0]
                    ) || 0}%`,
                    bgcolor: getHealthColor(
                      Number(
                        systemHealthDetails.cpu_temperature?.toString()?.split(".")[0]
                      ) || 0
                    ),
                    borderRadius: 10,
                    transition: "width 0.4s ease",
                  }}
                />
              </Box>
            </Box> */}

            {/* Memory Usage */}
            {/* <Box sx={{ width: 220 }}>
              <Typography fontWeight={600} sx={{ mb: 0.5 }}>
                Memory Usage: {systemHealthDetails.memory_usage?.percentage}
              </Typography>
              <Box
                sx={{
                  height: 12,
                  width: "100%",
                  bgcolor: "#e0e0e0",
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${Number(
                      systemHealthDetails.memory_usage?.percentage.replace(
                        "%",
                        ""
                      )
                    )}%`,
                    bgcolor: getHealthColor(
                      Number(
                        systemHealthDetails.memory_usage?.percentage.replace(
                          "%",
                          ""
                        )
                      )
                    ),
                    borderRadius: 10,
                    transition: "width 0.4s ease",
                  }}
                />
              </Box>
            </Box> */}

            {/* Disk Usage (better displayed than before) */}
            <Box sx={{ width: 220 }}>
              <Typography fontWeight={600} sx={{ mb: 0.5 }}>
                Disk Usage: {systemHealthDetails.disk_usage?.percentage || "0%"}
              </Typography>
              <Box
                sx={{
                  height: 12,
                  width: "100%",
                  bgcolor: "#e0e0e0",
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${Number(
                      systemHealthDetails.disk_usage?.percentage?.replace("%", "") || 0
                    )}%`,
                    bgcolor: getHealthColor(
                      Number(
                        systemHealthDetails.disk_usage?.percentage?.replace(
                          "%",
                          ""
                        )
                      ) || 0
                    ),
                    borderRadius: 10,
                    transition: "width 0.4s ease",
                  }}
                />
              </Box>
            </Box>

            {/* Vib360 Status */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
              <Typography fontWeight={600}>Vib360 Status:</Typography>
              <FaCircle
                color={vib360RunningStatus == "Running" ? "green" : "red"}
                size={12}
              />
              <Typography
                sx={{
                  color: vib360RunningStatus == "Running" ? "green" : "red",
                  fontWeight: 700,
                }}
              >
                {vib360RunningStatus}
              </Typography>
            </Box>
          </Box>
        )}

        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid #7070704B",
                borderRadius: 5,
                bgcolor: "#E8E8ED",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  px: 4,
                  py: 2,
                }}
              >
                <Typography variant="h5">Hardware information</Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">
                      Hardware Serial Number :{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {apiData?.serialNo}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">Mac ID : </Typography>
                    <Typography variant="body1" sx={{ ml: 1 }}>
                      {apiData?.macId}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">
                      Firmware Number :{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {apiData?.firmwareVersion}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle1">User Manual : </Typography>
                    <Link
                      variant="body1"
                      color="#002BBC"
                      href="/hardware_manual.pdf"
                      sx={{ mx: 1 }}
                      download
                      target="_blank"
                    >
                      Download Hardware User Manual.pdf
                    </Link>
                  </Box>
                </Box>
              </Box>
              <Divider sx={{ mx: 4 }} />
              <Box sx={{ px: 4, py: 2 }}>
                <Typography variant="h5">
                  Software information
                  <InfoIcon
                    onMouseEnter={() => setIsShown(true)}
                    onMouseLeave={() => setIsShown(false)}
                  ></InfoIcon>
                </Typography>
                {isShown && (
                  <Box
                    component="p"
                    sx={{
                      bgcolor: "#F5F5F5",
                      position: "absolute",
                      width: "50%",
                      padding: "7px",
                      borderRadius: "10px",
                    }}
                  >
                    {apiData?.softwareNote}
                  </Box>
                )}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">UI Version: </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {apiData?.softwareVersion}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">
                      Software user manual :{" "}
                    </Typography>
                    <Link
                      variant="body1"
                      color="#002BBC"
                      href="/software_manual.pdf"
                      sx={{ mx: 1 }}
                      download
                      target="_blank"
                    >
                      Download Software User Manual.pdf
                    </Link>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">
                      Software Version :{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {versionData?.version || "Loading..."}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Divider sx={{ mx: 4 }} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  px: 4,
                  py: 2,
                }}
              >
                <Typography variant="h5">License Details</Typography>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">
                      License Number:{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {apiData?.licenseInfo?.license_number}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">
                      License Tenure (Months) :{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {apiData?.licenseInfo?.license_tenure}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">
                      Activation date:{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {apiData?.licenseInfo?.activation_date}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <Typography variant="subtitle1">Expiry date: </Typography>
                    <Typography variant="body1" sx={{ mx: 1 }}>
                      {apiData?.licenseInfo?.expiry_date}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Divider sx={{ my: 5 }} />
          <Box>
            <SystemInfoTable systemInfo={apiData?.licenseInfo} />
          </Box>
          <Divider sx={{ my: 5 }} />
          <Box>
            <Accordion sx={{ bgcolor: "#EAEAEA" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="subtitle2"> License History</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <NotActiveLicenseTable
                  notActiveLicenseInfo={apiData?.notActiveLicenseInfo || []}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
          <Divider sx={{ my: 5 }} />
          <Box
            sx={{
              display: "flex",
              // p: 2,
            }}
          >
            <UploadFile setApiData={setApiData} versionData={versionData} />
          </Box>
        </Box>
        {showCommandConsole && (
          <Box sx={{ mt: 3 }}>
            <CommandConsole />

            <Button
              sx={{ mt: 2 }}
              variant="outlined"
              color="error"
              onClick={() => setShowCommandConsole(false)}
            >
              Close Console
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default SystemConfiguration;
